var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTourFeedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4029 0.957031H3.18072C1.9585 0.957031 0.958496 1.95703 0.958496 3.17925V18.7348C0.958496 19.957 1.9585 20.957 3.18072 20.957H18.7363C19.9585 20.957 20.9585 19.957 20.9585 18.7348V6.51259L15.4029 0.957031ZM18.7363 18.7348H3.18072V3.17925H14.2918V7.6237H18.7363V18.7348ZM5.40294 16.5126H16.5141V14.2904H5.40294V16.5126ZM10.9585 5.40148H5.40294V7.6237H10.9585V5.40148ZM5.40294 12.0681H16.5141V9.84592H5.40294V12.0681Z",
    fill: "#171A21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourFeedIcon);
export default __webpack_public_path__ + "static/media/tour-feed-icon.f93f311858a6d8426697dc389e6e4e7a.svg";
export { ForwardRef as ReactComponent };